import { useQuery } from '@tanstack/react-query';
import { postAsync } from '@/helpers/http-request';

type VerifyTokenParams = {
  userId: string | null;
  token: string | null;
}

type TokenVerifyResult = 'valid' | 'invalid' | 'error';

const useVerifyResetToken = (userId: string | null, token: string | null) => {
  const { data, isLoading } = useQuery({
    queryKey: ['verifyResetToken', userId, token],
    queryFn: async (): Promise<TokenVerifyResult> => {
      const params: VerifyTokenParams = { userId, token };

      if (!params.userId || !params.token) {
        return 'invalid';
      }

      const response = await postAsync('/web/v1/user/verifyResetPasswordToken', {
        userId: params.userId,
        token: params.token,
      });

      if (response.ok) {
        return 'valid';
      }

      if (response.status === 400) {
        return 'invalid';
      }

      return 'error';
    },
    enabled: !!userId && !!token,
    retry: false,
    staleTime: Infinity,
  });

  return {
    result: data,
    isLoading,
    isValid: data === 'valid',
    isInvalid: data === 'invalid',
    isError: data === 'error',
  };
}

export default useVerifyResetToken;